import { includes } from 'lodash';

export function loginRequired(
  $state,
  $auth,
  $rootScope
) {
  'ngInject';
  $rootScope.$on('$stateChangeStart', function (event, toState) {
    const openModules = ['signin', 'password'];
    if(!includes(openModules, toState.name) && $auth.isAuthenticated() === false) {
      event.preventDefault();
      $state.go('signin');
    }

  });
}


/** WEBPACK FOOTER **
 ** ./frontend/bootstrap/loginRequired.run.js
 **/